/** Schedule work after the first paint (load + double rAF + idle). */
export function runAfterFirstPaint(callback: () => void): void {
  if (typeof window === 'undefined') return;

  const schedule = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(() => callback(), { timeout: 2000 });
        } else {
          setTimeout(callback, 0);
        }
      });
    });
  };

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
}
